import ReactDOM from 'react-dom'
import React, { useState } from 'react'
import {
  BrowserRouter as Router,
  Route,
  Routes
} from 'react-router-dom'
import constructionWorkers from './assets/construction-workers.webp';
import electrician from './assets/electrician.webp';
import plumber from './assets/plumber.webp';
import painter from './assets/painter.jpg';
import carpenter from './assets/carpenter.jpg';
import mason from './assets/mason.jpg';
import welding from './assets/welding.jpg';
import hvac from './assets/hvac.jpg';
import scaffolding from './assets/scaffolding.jpg';
import './style.css'
import SplashScreen from './components/SplashScreen'
import UserTypeSelection from './components/UserTypeSelection'
import Home from './views/home'
import NotFound from './views/not-found'
import Signup from './components/Signup'
import Login from './components/Login'
import AttendancePage from './components/AttendancePage';
import FieldSelection from './components/FieldSelection'
import BrowseJobs from './components/BrowseJobs'
import PostJob from './components/PostJob'
import WagesPage from './components/WagesPage';
import ContractorWagesPage from './components/ContractorWagesPage';
import BottomNavbar from './components/BottomNavbar';
import Pricing14 from './components/pricing14';
import LabourPricing from './components/LabourPricing';


const App = () => {
  const [isSplashComplete, setIsSplashComplete] = useState(
    sessionStorage.getItem('splashShown') === 'true'
  );

  const handleSplashComplete = () => {
    sessionStorage.setItem('splashShown', 'true');
    setIsSplashComplete(true);
  };

  const [jobListings, setJobListings] = useState([
    {
      id: 1,
      name: 'Construction Workers Team',
      image: constructionWorkers,
      rating: 4.8,
      experience: '5+ years',
      skills: ['Masonry', 'Concrete Work', 'Scaffolding'],
      location: 'Mumbai',
      rate: '₹800/day',
      completedJobs: 45
    },
    {
      id: 2,
      name: 'Electrician Services',
      image: electrician,
      rating: 4.5,
      experience: '8+ years',
      skills: ['Wiring', 'Electrical Maintenance', 'Panel Installation'],
      location: 'Delhi',
      rate: '₹1200/day',
      completedJobs: 32
    },
    {
      id: 3,
      name: 'Plumbing Experts Team',
      image: plumber,
      rating: 4.5,
      experience: '8+ years',
      skills: ['Pipeline Installation', 'Leak Repair', 'Bathroom Fitting'],
      location: 'Bangalore',
      rate: '₹1,800/day',
      completedJobs: 65
    },
    {
      id: 4,
      name: 'Carpentry Specialists',
      image: carpenter,
      rating: 4.6,
      experience: '10+ years',
      skills: ['Furniture Making', 'Wood Carving', 'Interior Woodwork'],
      location: 'Chennai',
      rate: '₹1,200/day',
      completedJobs: 142
    },
    {
      id: 5,
      name: 'Painting Contractors',
      image: painter,
      rating: 4.3,
      experience: '6+ years',
      skills: ['Wall Painting', 'Texture Finishes', 'Waterproof Coating'],
      location: 'Hyderabad',
      rate: '₹900/day',
      completedJobs: 203
    },
    {
      id: 6,
      name: 'Masonry Professionals',
      image: mason,
      rating: 4.8,
      experience: '9+ years',
      skills: ['Brick Laying', 'Concrete Work', 'Floor Tiling'],
      location: 'Pune',
      rate: '₹1,100/day',
      completedJobs: 178
    },
    {
      id: 7,
      name: 'Welding Specialist',
      image: welding,
      rating: 4.4,
      experience: '7+ years',
      skills: ['ARC Welding', 'Metal Fabrication', 'Structural Welding'],
      location: 'Ahmedabad',
      rate: '₹1,600/day',
      completedJobs: 92
    },
    {
      id: 8,
      name: 'HVAC Technicians',
      image: hvac,
      rating: 4.7,
      experience: '11+ years',
      skills: ['AC Installation', 'Ventilation Systems', 'Maintenance'],
      location: 'Kolkata',
      rate: '₹1,750/day',
      completedJobs: 114
    },
    {
      id: 9,
      name: 'Scaffolding Experts',
      image: scaffolding,
      rating: 4.2,
      experience: '5+ years',
      skills: ['Temporary Structures', 'Safety Setup', 'Construction Support'],
      location: 'Surat',
      rate: '₹950/day',
      completedJobs: 85
    }
  ]);

  // Function to add new job
  const addJob = (newJob) => {
    setJobListings((prevJobs) => [{ id: prevJobs.length + 1, ...newJob }, ...prevJobs]);
  };

  const [isLoggedIn, setIsLoggedIn] = useState(
    sessionStorage.getItem('isLoggedIn') === 'true'
  );

  return (
    <Router>
      {!isSplashComplete ? (
        <SplashScreen onSplashComplete={handleSplashComplete} />
      ) : (
        <>
        <Routes>
          <Route path="/" element={<UserTypeSelection />} />
          <Route path= "/attendance" element={<AttendancePage />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/subscriptions" element={<Pricing14 />} />
          <Route path="/labour-subscription" element={<LabourPricing />} />
          <Route path="/field-selection" element={<FieldSelection />} />
          <Route path="/wages" element={<WagesPage />} />
          <Route path="/wages-admin" element={<ContractorWagesPage />} />
          <Route path="/browse-jobs" element={<BrowseJobs jobListings={jobListings}/>} />
          <Route path="/post-job" element={<PostJob addJob={addJob} />} />
          <Route path="/home" element={<Home />} />
          <Route path="*" element={<NotFound />} />
        </Routes>

        <BottomNavbar />
        </>
      )}
    </Router>
  );
};

ReactDOM.render(<App />, document.getElementById('app'));
